export const SET_CARD_EXERCISE_TYPE = 'SET_CARD_EXERCISE_TYPE';
export const SET_MODAL_CARD_TYPE = 'SET_MODAL_CARD_TYPE';
export const GET_BOOK_FLASH_CARD_INFO_SUCCESS = 'GET_BOOK_FLASH_CARD_INFO_SUCCESS';
export const GET_BOOK_FLASH_CARD_FILTER_SUCCESS = 'GET_BOOK_FLASH_CARD_FILTER_SUCCESS';
export const CHECK_FILTER_READING = 'CHECK_FILTER_READING';
export const TOGGLE_ALL_FILTER_READING = 'TOGGLE_ALL_FILTER_READING';
export const CHECK_FILTER_REVISE_SWITCH = 'CHECK_FILTER_REVISE_SWITCH';
export const SET_BOOK_FLASH_CARD_LIST = 'SET_BOOK_FLASH_CARD_LIST';
export const SET_IDX_CARD = 'SET_IDX_CARD';
export const SET_FLASH_CARD_DETAIL = 'SET_FLASH_CARD_DETAIL';
export const ANSWER_FLASH_CARD_SUCCESS = 'ANSWER_FLASH_CARD_SUCCESS';
export const SET_IS_SHOW_ANSWER = 'SET_IS_SHOW_ANSWER';
export const SET_IS_FLASH_CARD_REPORTED = 'SET_IS_FLASH_CARD_REPORTED';
export const TOGGLE_FAVORITE_FLASH_CARD_SUCCESS = 'TOGGLE_FAVORITE_FLASH_CARD_SUCCESS';
export const LOADING_MESSAGE = '加载中...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_IS_FILTER_REQUEST_STATUS = 'SET_IS_FILTER_REQUEST_STATUS';
export const SET_IS_ANSWER_REQUEST_STATUS = 'SET_IS_ANSWER_REQUEST_STATUS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
